import { render, staticRenderFns } from "./AuthPanel.vue?vue&type=template&id=67b573f0&scoped=true"
import script from "./AuthPanel.vue?vue&type=script&lang=js"
export * from "./AuthPanel.vue?vue&type=script&lang=js"
import style0 from "./AuthPanel.vue?vue&type=style&index=0&id=67b573f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b573f0",
  null
  
)

export default component.exports